import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-span-6" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = { class: "col-span-6" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = { class: "col-span-6" }
const _hoisted_6 = {
  key: 0,
  class: "col-span-6"
}

import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';

import { onMounted, ref, computed } from 'vue';
import AdminData from '@/classes/AdminData';
import DropdownData from '@/classes/DropdownData';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    form: {
        type: Object,
        required: true
    },
    errors: {
        type: Array,
        required: true
    }
},
  setup(__props) {

const props = __props;

const item = ref(props.form)
const roles = ref([]);
const companies = ref([]);

const fetchRoles = async () => {
    const response = await AdminData.getRoles();
    roles.value = response.data
}

/**
 * Fetch companies
 */
 const fetchCompanies = async () => {
    const response = await DropdownData.getCompanies();
    companies.value = response.data.response.map((company: any) => ({
        id: company.id,
        label: company.name,
        value: company.id
    }));
}

const selectedRole = computed(() => {
    return roles.value.find(r => r.id == item.value.role_id)?.label
})


onMounted(() => {
    fetchRoles();
    fetchCompanies();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormSection, null, {
    title: _withCtx(() => [...(_cache[6] || (_cache[6] = [
      _createTextVNode(" Admin Information ", -1)
    ]))]),
    description: _withCtx(() => [...(_cache[7] || (_cache[7] = [
      _createTextVNode(" Relevant data and other details ", -1)
    ]))]),
    form: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TextInput, {
          modelValue: item.value.first_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.first_name) = $event)),
          id: "first_name",
          name: "first_name",
          label: "First Name",
          placeholder: "First Name",
          error: __props.errors.first_name ? __props.errors.first_name[0] : ''
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TextInput, {
          modelValue: item.value.last_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.last_name) = $event)),
          id: "last_name",
          name: "last_name",
          label: "Last Name",
          placeholder: "Last Name",
          error: __props.errors.last_name ? __props.errors.last_name[0] : ''
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TextInput, {
          modelValue: item.value.email,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.email) = $event)),
          id: "email",
          name: "email",
          label: "Email Address",
          placeholder: "Email Address",
          error: __props.errors.email ? __props.errors.email[0] : ''
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TextInput, {
          modelValue: item.value.mobile_number,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.mobile_number) = $event)),
          id: "mobile_number",
          name: "mobile_number",
          label: "Mobile Number",
          placeholder: "Mobile Number",
          addOnLeft: "",
          addOnText: "+63",
          maxlength: 10,
          oninput: "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*)\\./g, '$1');",
          error: __props.errors.mobile_number ? __props.errors.mobile_number[0] : ''
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(MultiselectInput, {
          id: "roles",
          name: "roles",
          label: "Role",
          modelValue: item.value.role_id,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.role_id) = $event)),
          placeholder: "Role",
          options: roles.value,
          searchable: "",
          error: __props.errors.role_id ? __props.errors.role_id[0] : ''
        }, null, 8, ["modelValue", "options", "error"])
      ]),
      (selectedRole.value == 'Corporate Account Admin')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(MultiselectInput, {
              id: "company",
              name: "company",
              label: "Company",
              modelValue: item.value.company_id,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((item.value.company_id) = $event)),
              placeholder: "Company",
              options: companies.value,
              searchable: "",
              error: __props.errors.company_id ? __props.errors.company_id[0] : ''
            }, null, 8, ["modelValue", "options", "error"])
          ]))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})